(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BA-CTA"] && !Shopify.designMode) return;
  try {
    
  var winW = $(window).outerWidth();
  console.log(winW);
  if (winW < 991) {

            $(".booking-cta_content_info").not('.slick-initialized').slick({
        		dots: true,
        		arrows: false,
                centerMode: true,
        		speed: 300,
        		autoplay: false,
        		slidesToShow: 1,
        		slidesToScroll: 1,
              responsive: [
          		{
          			breakpoint: 991,
          			settings: {
          				slidesToShow: 2,
          				slidesToScroll: 1,
          			},
          		},
          		{
          			breakpoint: 767,
          			settings: {
          				slidesToShow: 1,
          			},
          		},
          	],
        	});

        }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Off-Products"] && !Shopify.designMode) return;
  try {
    
  var popularSlider = $(".popular_sliderxxx").slick({
      	dots: true,
      	arrows: true,
      	autoplay: false,
      	infinite: true,
      	slidesToShow: 4,
      	slidesToScroll: 1,
      	pauseOnHover: false,
      	autoplaySpeed: 3000,
      	prevArrow:
      		"<img class='a-left control-c prev slick-prev img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/files/prev.png'>",
      	nextArrow:
      		"<img class='a-right control-c next slick-next img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/files/next.png'>",
      	responsive: [
      		{
      			breakpoint: 1024,
      			settings: {
      				slidesToShow: 2,
      				slidesToScroll: 1,
      			},
      		},
      		{
      			breakpoint: 767,
      			settings: {
      				autoplay: true,
      				slidesToShow: 1,
      				speed: 1000,
      				arrows: false,
      				variableWidth: true,
      			},
      		},
      	],
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Pro-Testimonial"] && !Shopify.designMode) return;
  try {
    
  const circlePlayButton = document.getElementById("circle-play-b");
  var play_pause_status = "pause";
  function togglePlay() {
    const video = document.getElementById(`${this.dataset.id}`);
  	if (play_pause_status == "pause") {
  		video.play();
        this.style.opacity = 0;
        play_pause_status = "play";
  	} else {
  		video.pause();
        this.style.opacity = 1;
        play_pause_status = "pause";
  	}
  }
  function videoPause(){
    document.querySelectorAll('video').forEach((video) => {
      video.pause();
      const circlePlayButton = document.querySelectorAll('.play-gif');
      
      video.addEventListener("pause", function () {
      	circlePlayButton.forEach(button => {button.style.opacity = 1;});
        play_pause_status = "pause";
      });
    });
  }
  document.querySelectorAll('.play-gif').forEach((circlePlayButton) => {
    circlePlayButton.addEventListener("click", togglePlay);
  });
  // document.querySelector('.slick-prev').addEventListener("click", videoPause);
  // document.querySelector('.slick-next').addEventListener("click", videoPause);

  $('.slider_one').on('afterChange', function(event, slick, currentSlide, nextSlide){
    videoPause();
  });

  //circlePlayButton.addEventListener("click", togglePlay);
  
  // video.addEventListener("playing", function () {
  // 	circlePlayButton.style.opacity = 0;
  // });
  // video.addEventListener("pause", function () {
  // 	circlePlayButton.style.opacity = 1;
  // });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Ss-Products"] && !Shopify.designMode) return;
  try {
    
  $(".product-subscriptions").not('.slick-initialized').slick({
          dots: true,
          arrows: true,
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 1000,
          autoplaySpeed: 3000,
          swipeToSlide: true,
          prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0775/1060/7155/files/prev.svg" class="slick-prev img-responsive">',
          nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0775/1060/7155/files/next.svg" class="slick-next img-responsive">',
          responsive: [{
                  breakpoint: 1199,
                  settings: {
                      slidesToShow: 3,
                      dots: true,
                      arrows: false,
                  },
              },
              {
                  breakpoint: 991,
                  settings: {
                      dots: true,
                      arrows: false,
                      slidesToShow: 2,
                      variableWidth: false
                  },
              },
              {
                  breakpoint: 767,
                  settings: {
                      dots: true,
                      arrows: false,
                    slidesToShow: 1,
                    centerMode: true,
                      variableWidth: false
                  },
              },
          ],
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Ss-Why"] && !Shopify.designMode) return;
  try {
    
  var winW = $(window).outerWidth();
  console.log(winW);
  if (winW < 991) {

            $(".why_content_info").not('.slick-initialized').slick({
        		dots: true,
        		arrows: false,
                centerMode: true,
        		speed: 300,
        		autoplay: false,
        		slidesToShow: 1,
        		slidesToScroll: 1,
              responsive: [
          		{
          			breakpoint: 991,
          			settings: {
          				slidesToShow: 2,
          				slidesToScroll: 1,
          			},
          		},
          		{
          			breakpoint: 767,
          			settings: {
          				slidesToShow: 1,
          			},
          		},
          	],
        	});

        }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  $(document).ready(function(){
    $(".block-title").click(function(){
      $(".block-content").toggle(100);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
